/** Ressources de traduction statiques ; les clés restent vérifiées par TypeScript. */
import textes from './traductions/promotions-publics.json' with { type: 'json' };
export const TEXTES_PROMOTIONS_PUBLICS = textes;
//# sourceMappingURL=textes-promotions-publics.js.map